import { jsx as o, Fragment as a, jsxs as g } from "react/jsx-runtime";
import { S as h } from "./index-CCavb-1K.js";
import { c as m } from "./index-BwYCDOHZ.js";
import { c as f } from "./clsx-OuTLNxxd.js";
import { forwardRef as d } from "react";
import { S as z } from "./Spinner-CQ8esd5Y.js";
const u = "320px", _ = "600px", S = "1025px", b = "_isVisuallyHidden_dz8l7_51", p = "_button_dz8l7_63", H = "_smallSize_dz8l7_98", B = "_defaultSize_dz8l7_106", W = "_largeSize_dz8l7_112", v = "_primary_dz8l7_120", k = "_secondary_dz8l7_126", F = "_tertiary_dz8l7_139", V = "_active_dz8l7_153", w = "_ghost_dz8l7_158", j = "_ghostBrand_dz8l7_159", C = "_outline_dz8l7_199", N = "_isFullWidth_dz8l7_211", t = {
  mobile: u,
  "mobile-wide": "480px",
  tablet: _,
  "tablet-wide": "800px",
  desktop: S,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: b,
  button: p,
  smallSize: H,
  defaultSize: B,
  largeSize: W,
  primary: v,
  secondary: k,
  tertiary: F,
  active: V,
  ghost: w,
  ghostBrand: j,
  outline: C,
  isFullWidth: N
}, R = m(t.button, {
  variants: {
    variant: {
      default: t.primary,
      ghost: t.ghost,
      ghostBrand: t.ghostBrand,
      secondary: t.secondary,
      tertiary: t.tertiary,
      active: t.active,
      outline: t.outline
    },
    size: {
      default: t.defaultSize,
      small: t.smallSize,
      large: t.largeSize
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), q = d(
  ({ isLoading: e, variant: i, loadingText: l, asChild: x, ...n }, s) => /* @__PURE__ */ o(a, { children: e ? /* @__PURE__ */ o(
    c,
    {
      ...n,
      ref: s,
      variant: i,
      "aria-busy": e,
      disabled: e,
      children: /* @__PURE__ */ g(a, { children: [
        l || "Loading",
        /* @__PURE__ */ o(
          z,
          {
            size: "s",
            variant: i === "secondary" ? "dark" : "light"
          }
        )
      ] })
    }
  ) : /* @__PURE__ */ o(c, { ...n, variant: i, ref: s, asChild: x }) })
), c = d(
  ({
    className: e,
    variant: i,
    size: l,
    disabled: x,
    isFullWidth: n,
    asChild: s = !1,
    ...y
  }, r) => /* @__PURE__ */ o(
    s ? h : "button",
    {
      className: f(
        R({ variant: i, size: l }),
        { [t.isFullWidth]: n },
        e
      ),
      disabled: x,
      ref: r,
      "data-testid": "button-component",
      ...y
    }
  )
);
q.displayName = "Button";
export {
  q as B,
  R as b
};
